/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Single_60Inputs */

const en_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single 1 hour lesson`)
};

const es_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una clase de 1 hora`)
};

const de_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelne einstündige Golfstunde`)
};

const zh_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单次 1 小时课程`)
};

const ar_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درس واحد لمدة ساعة`)
};

const fr_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une leçon d'1 heure`)
};

const vi_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một buổi học 1 giờ`)
};

const sw_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somo moja la saa 1`)
};

const th_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนเดี่ยว 1 ชั่วโมง`)
};

const bs_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedan čas od 1 sata`)
};

const ja_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1時間レッスン（単発）`)
};

const ko_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1시간 레슨 (단일)`)
};

const pt_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma aula de 1 hora`)
};

const it_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una lezione singola da 1 ora`)
};

const sv_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lektion på 1 timme`)
};

const nl_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een enkele les van 1 uur`)
};

const da_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Én lektion på 1 time`)
};

const nb_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Én leksjon på 1 time`)
};

const fi_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhden tunnin oppitunti`)
};

const pl_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pojedyncza lekcja 1-godzinna`)
};

const ru_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один урок на 1 час`)
};

const tr_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek 1 saatlik ders`)
};

const hi_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 घंटे का एकल पाठ`)
};

const id_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pelajaran 1 jam`)
};

const ms_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu pelajaran 1 jam`)
};

const cs_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedna hodinová lekce`)
};

const el_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα μάθημα 1 ώρας`)
};

const he_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור בודד של שעה אחת`)
};

const af_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Enkele les van 1 uur`)
};

const hu_prices_label_single_60 = /** @type {(inputs: Prices_Label_Single_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egy 1 órás alkalom`)
};

/**
* | output |
* | --- |
* | "A single 1 hour lesson" |
*
* @param {Prices_Label_Single_60Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_single_60 = /** @type {((inputs?: Prices_Label_Single_60Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Single_60Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_single_60(inputs)
	if (locale === "de") return de_prices_label_single_60(inputs)
	if (locale === "zh") return zh_prices_label_single_60(inputs)
	if (locale === "ar") return ar_prices_label_single_60(inputs)
	if (locale === "fr") return fr_prices_label_single_60(inputs)
	if (locale === "vi") return vi_prices_label_single_60(inputs)
	if (locale === "sw") return sw_prices_label_single_60(inputs)
	if (locale === "th") return th_prices_label_single_60(inputs)
	if (locale === "bs") return bs_prices_label_single_60(inputs)
	if (locale === "ja") return ja_prices_label_single_60(inputs)
	if (locale === "ko") return ko_prices_label_single_60(inputs)
	if (locale === "pt") return pt_prices_label_single_60(inputs)
	if (locale === "it") return it_prices_label_single_60(inputs)
	if (locale === "sv") return sv_prices_label_single_60(inputs)
	if (locale === "nl") return nl_prices_label_single_60(inputs)
	if (locale === "da") return da_prices_label_single_60(inputs)
	if (locale === "nb") return nb_prices_label_single_60(inputs)
	if (locale === "fi") return fi_prices_label_single_60(inputs)
	if (locale === "pl") return pl_prices_label_single_60(inputs)
	if (locale === "ru") return ru_prices_label_single_60(inputs)
	if (locale === "tr") return tr_prices_label_single_60(inputs)
	if (locale === "hi") return hi_prices_label_single_60(inputs)
	if (locale === "id") return id_prices_label_single_60(inputs)
	if (locale === "ms") return ms_prices_label_single_60(inputs)
	if (locale === "cs") return cs_prices_label_single_60(inputs)
	if (locale === "el") return el_prices_label_single_60(inputs)
	if (locale === "he") return he_prices_label_single_60(inputs)
	if (locale === "af") return af_prices_label_single_60(inputs)
	if (locale === "hu") return hu_prices_label_single_60(inputs)
	return en_prices_label_single_60(inputs)
});